//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "@/observable/store"
import { inspectOrder } from '../../model/trader/orderService'
import {successText} from '@/utils/commonUtils'

export default {
    name: "quota",
    data(){
        return {
        }
    },
    created() {},
    mounted(){
      this.STATISTICS('load','sybao_ins_pay_failed_page')

    },
    methods: {
      again() {
        
      },
    },
   
}
